import { ContentCard } from "@msuite/ui/content-card";
import { getProtocolTypeIcon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { ProtocolTypeTag } from "@msuite/ui/tag";
import { moment } from "@msuite/utils/date";
import { getProtocolTypeColor } from "@msuite/utils/protocols";
import { guardString } from "@msuite/utils/strings";
import type { ProtocolType } from "@msuite/utils/types";
import { useProtocol } from "@/hooks/use-protocol";
import type { ProtocolPanelBaseProps } from "./shared";

export function ProtocolHeader({ protocolId }: ProtocolPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { protocol } = useProtocol(protocolId);

	/** Guard */
	if (!protocol) return null;

	/** Render */
	return (
		<ContentCard
			icon={icon(getProtocolTypeIcon(protocol.type as ProtocolType))}
			title={protocol.title || t("protocols.untitled")}
			identifier={protocol.id}
		>
			<div className="justify-between h-stack">
				<ProtocolTypeTag
					type={protocol.type}
					color={getProtocolTypeColor(protocol.type)}
					variant="plain"
				/>
				<p className="tabular-nums">
					{protocol.date ? moment(protocol.date).dateFormat() : guardString(null)}
				</p>
			</div>
		</ContentCard>
	);
}
